import { useMemo } from "react";

export const useGetStep = (options, value) => {
  return useMemo(() => {
    const option = options.find((option) => option.id === value);
    return option;
  }, [options, value]);
};
